var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppTest = function SvgAppTest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.5C0 4.25 4.25 0 9.5 0S19 4.25 19 9.5 14.75 19 9.5 19 0 14.75 0 9.5zm18 0C18 4.8 14.2 1 9.5 1S1 4.8 1 9.5 4.8 18 9.5 18 18 14.2 18 9.5zm-9.53 2.76L13.6 5.7l.8.6-5.86 7.45-3.4-3.4.7-.7 2.63 2.6z"
  })));
};
export default SvgAppTest;